// ESM-Huelle fuer lib/scripts/components/CMP_CTableBody.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CTableBody (id)
{
    this.construct (id);

    this.name = "CTableBody";    
    this.htmlType = "tbody";
    
    this.properties = {};
}

CTableBody.prototype = new CComponent;
export { CTableBody };
